const API_ENDPOINTS = {
  getAddressURL: '/offer_gfseext/customer',
  getAutocompleteURL: '/customer_gfseext/nav/customer/lookup',
};

export const selectEnvironment = () => {
  return API_ENDPOINTS;
};
